"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheClear = exports.cacheRemove = exports.cacheGet = exports.cacheSet = void 0;
var cacheSet = function (key, value) {
    localStorage.setItem(key, value);
};
exports.cacheSet = cacheSet;
var cacheGet = function (key) {
    return localStorage.getItem(key);
};
exports.cacheGet = cacheGet;
var cacheRemove = function (key) {
    localStorage.removeItem(key);
};
exports.cacheRemove = cacheRemove;
var cacheClear = function () {
    localStorage.clear();
};
exports.cacheClear = cacheClear;
//# sourceMappingURL=CacheManager.js.map